import { ColumnApi, GridApi, GridReadyEvent } from 'ag-grid-community';
import React, { createContext, useContext, useState } from 'react';
import { Task } from 'data/tasks/schema';
import { useGrid } from 'hooks/use-grid';

type TaskSelectionContext = {
  selectedTasksGridApi: GridApi | null;
  selectedTasksGridColumnApi: ColumnApi | null;
  selectedTasksOnGridReady: (event: GridReadyEvent) => void;
  allTasksOnGridReady: (event: GridReadyEvent) => void;
  allTasksGridApi: GridApi | null;
  allTasksGridColumnApi: ColumnApi | null;
  selectedTasks: Task[];
  setSelectedTasks: React.Dispatch<any>;
  selectedTasksLookup: Record<number, boolean>;
};

export const TaskSelectionContext =
  createContext<TaskSelectionContext | null>(null);

export const TaskSelectionProvider = ({ children }) => {
  const {
    gridApi: selectedTasksGridApi,
    gridColumnApi: selectedTasksGridColumnApi,
    onGridReady: selectedTasksOnGridReady,
  } = useGrid();

  const {
    gridApi: allTasksGridApi,
    gridColumnApi: allTasksGridColumnApi,
    onGridReady: allTasksOnGridReady,
  } = useGrid();

  const [selectedTasks, setSelectedTasks] = useState([] as Task[]);

  const selectedTasksLookup = selectedTasks.reduce((acc, task) => {
    acc[task.taskId] = true;

    return acc;
  }, {});

  return (
    <TaskSelectionContext.Provider
      value={{
        selectedTasksGridApi,
        selectedTasksGridColumnApi,
        selectedTasksOnGridReady,
        allTasksOnGridReady,
        allTasksGridApi,
        allTasksGridColumnApi,
        selectedTasks,
        setSelectedTasks,
        selectedTasksLookup,
      }}
    >
      {children}
    </TaskSelectionContext.Provider>
  );
};

export const useTaskSelectionContext = () => {
  const context = useContext(TaskSelectionContext);

  if (!context) {
    throw new Error(
      'This context hook must be used within a <LookupContextProvider>.',
    );
  }

  return context;
};
